import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import Input from 'src/components/Common/Input';
import createLogger from 'src/utils/logger';
import { Reviews } from 'src/api';
import { Mixpanel } from '../../Mixpanel';

import star from './star.svg'
import './AddReview.scss';


class RadioInputs extends Component {
  constructor() {
    super();
    this.state = {
      value: 0,
    }
  }
  onClick = (e) => {
    e.preventDefault();
    this.setState(
      { value: parseInt(e.target.value, 10)},
      () => this.props.onChange(this.props.name, this.state.value),
    );
  }
  onMouseOver = (e) => {

  }
  onMouseLeave = (e) => {

  }
  isChecked = (value) => {
    return this.state.value && this.state.value >= value;
  }
  render() {
    const { name } = this.props.name;
    return (
      <div className="modal--input__radio">
        <span className="radio-input">
          <input type="radio" name={name} value="1" onClick={this.onClick}
            onMouseOver={this.onMouseOver} onMouseLeave={this.onMouseLeave} />
          <span className={`${this.isChecked(1) ? 'checked' : ''} star`}>
            <img alt="makr" src={star} />
          </span>
        </span>
        <span className="radio-input">
          <input type="radio" name={name} value="2" onClick={this.onClick}
            onMouseOver={this.onMouseOver} onMouseLeave={this.onMouseLeave} />
          <span className={`${this.isChecked(2) ? 'checked' : ''} star`}>
            <img alt="makr" src={star} />
          </span>
        </span>
        <span className="radio-input">
          <input type="radio" name={name} value="3" onClick={this.onClick}
            onMouseOver={this.onMouseOver} onMouseLeave={this.onMouseLeave} />
          <span className={`${this.isChecked(3) ? 'checked' : ''} star`}>
            <img alt="makr" src={star} />
          </span>
        </span>
        <span className="radio-input">
          <input type="radio" name={name} value="4" onClick={this.onClick}
            onMouseOver={this.onMouseOver} onMouseLeave={this.onMouseLeave} />
          <span className={`${this.isChecked(4) ? 'checked' : ''} star`}>
            <img alt="makr" src={star} />
          </span>
        </span>
        <span className="radio-input">
          <input type="radio" name={name} value="5" onClick={this.onClick}
            onMouseOver={this.onMouseOver} onMouseLeave={this.onMouseLeave} />
          <span className={`${this.isChecked(5) ? 'checked' : ''} star`}>
            <img alt="makr" src={star} />
          </span>
        </span>
      </div>
    )
  }
}

RadioInputs.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
}

class ShareInfo extends Component {
  constructor() {
    super();
    this.logger = createLogger('ShareInfo');
    this.state = {
      hackathon: '',
      hackathonError: false,
      atmosphere_mark: 0,
      organization_mark: 0,
      prize_mark: 0,
      aftertaste_mark: 0,
      comments: '',
      commentsError: false,
      sendingRequest: false,
    };
  }

  componentDidMount() {
    Mixpanel.track('Open add review')
  }


  onOptionChange = (name, value) => {
    this.logger.info('onOptionChange()', name, value);
    this.setState({ [name]: value })
  }

  handleInputChange = (e) => {
    e.preventDefault();
    this.setState({
      [e.target.name]: e.target.value,
      [e.target.name + "Error"]: false,
    });
  }

  createReviewForm = () => {
    const { hackathon, comments, atmosphere_mark, organization_mark, prize_mark, aftertaste_mark } = this.state;
    const reviewForm = {
      hackathon,
      comments,
      atmosphere: {
        mark: atmosphere_mark,
      },
      organization: {
        mark: organization_mark,
      },
      prize: {
        mark: prize_mark,
      },
      aftertaste: {
        mark: aftertaste_mark,
      },
    }
    this.logger.info('submitReview() - review', reviewForm);
    return reviewForm;
  }

  submitReview = (e) => {
    Mixpanel.track('Send review')

    e.preventDefault();
    e.stopPropagation();
    this.setState({
      sendingRequest: true,
    });
    
    Reviews.createReview(this.createReviewForm())
      .then((response) => {
        this.setState(
          { sendingRequest: false },
          () => this.onAddReviewSuccess(response), 
        );
      })
      .catch((e) => {
        this.setState({ sendingRequest: false },
          () => this.onAddReviewError(e.response),
        );
      });
  }

  onAddReviewSuccess = (res) => {
    this.logger.info('onAddReviewSuccess()', res.data);
    toast.success(`Спасибо за отзыв по хакатону "${res.data.hackathon}"!`);
    this.props.closeModal();
  }

  onAddReviewError = (res) => {
    if (res.status !== 400) {
      toast.error('Что-то пошло не так :(');
      return;
    }

    if (res.data.user) { // aka username
      toast.error('Вы должны быть авторизованы, чтобы отправить отзыв!');
      this.props.closeModal();
      return;
    }

    const errState = {};

    Object.keys(res.data).forEach((errKey) => {
      errState[errKey + 'Error'] = res.data[errKey];
    })
    this.setState({ ...errState });
    const toastErrMsg = (
      <div>
        Не все поля заполнены:
        {
          Object.keys(res.data).map(err => (<div key={err + res.data[err]}>{err}</div>))
        }
      </div>
    )
    toast.error(toastErrMsg);
  }

  render() {
    return (
      <div className="modal add-review">
        <form onSubmit={this.submitReview}>
          <h1>Оставить отзыв</h1>
          <Input className="modal--input-block modal--input-block__column"
            labelText="Название хакатона"
            name="hackathon"
            placeholder="Название хакатона"
            onChange={this.handleInputChange}
            errors={this.state.hackathonError}
          />
          <div className="modal--input-block modal--input-block__row">
            <div className="add-review--rating__category">
              <label>Атмосфера</label>
              <RadioInputs name="atmosphere_mark" onChange={this.onOptionChange} />
              <div className="add-review--hint">
                <b>Подсказка:</b> оценивается, насколько ты ощущал себя в IT-сообществе и прочувствовал ли ты дух страны(города), в которой прибывал
              </div>
            </div>
            <div className="add-review--rating__category">
              <label>Организация</label>
              <RadioInputs name="organization_mark" onChange={this.onOptionChange} />
              <div className="add-review--hint">
                <b>Подсказка:</b> оценивается работа организаторов на хакатоне. Были ли проблемы с едой, рабочим местом, посторонние на площадке и т.д. Смело пиши в этот раздел, а если не было - пиши, какие все красавчики
              </div>
            </div>
          </div>
          <div className="modal--input-block modal--input-block__row">
            <div className="add-review--rating__category">
              <label>Призы</label>
              <RadioInputs name="prize_mark" onChange={this.onOptionChange} />
              <div className="add-review--hint">
                <b>Подсказка:</b> оценивается как наличие лута, по типу наклеек, футболок, так и награды за призовые места и номинации
              </div>
            </div>
            <div className="add-review--rating__category">
              <label>Послевкусие</label>
              <RadioInputs name="aftertaste_mark" onChange={this.onOptionChange} />
              <div className="add-review--hint">
                <b>Подсказка:</b> оценивается желание вернуться на данное мероприятие вновь или наоборот - забыть как страшный сон, наличие положительных/отрицательных воспоминаний
              </div>
            </div>
          </div>
          <Input className="modal--input-block modal--input-block__column"
            labelText="Общая оценка хакатона"
            name="comments"
            placeholder="Введите комментарий"
            onChange={this.handleInputChange}
            errors={this.state.commentsError}
            isTextArea={true}
          />
          <div className="modal-buttons">
            <button className="btn btn_black" onClick={this.submitReview} disabled={this.state.sendingRequest}>Добавить</button>
            <button className="btn btn_cancel" onClick={this.props.closeModal}>Отменить</button>
          </div>
        </form>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    username: state.user.username,
  }
}

ShareInfo.propTypes = {
  username: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
}

export default connect(mapStateToProps, {})(ShareInfo);



// WEBPACK FOOTER //
// ./src/components/Modal/AddReview/index.js